module.exports = __webpack_public_path__ + "img/idcardf.75df1f22.png";